import React, { useEffect, useState } from 'react';
import {
  AppDatePicker,
  AppFileUploader,
  AppInput,
  AppInputNumber,
  AppMultiSelect,
  AppRemixIcon,
  AppSingleSelect,
  AppTextArea,
} from '@/layout/AppComponents';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Formik } from 'formik';
import Moment from 'moment';
import * as Yup from 'yup';
import ReactDOMServer from 'react-dom/server';
import { axiosPath } from '../../../../../../../routing/helpers/router';
import * as currentPageAction from '../../../../../../../store/actions/currentPageAction';
import Translator from '../../../../../../components/helpers/Translator';
import { toFormData } from '../../../../../../../minions/forms';
import AppTextEditor from '../../../../../../components/form/Texts/AppTextEditor';
import errorHandler from '@/layout/components/error/ErrorHandler';

const CorrectiveActionsNewTaskUpdate = (props) => {
  const { plantObligationID, onCreated, modulePermissions, selectedTask } =
    props;
  const { moduleBridgeHex, plantHex } = useParams();
  const dispatch = useDispatch();
  const permissions = useSelector(
    (state) => state.module[moduleBridgeHex].permissions
  );
  const user = useSelector((state) => state.auth?.user);
  const userBridge = useSelector(
    (state) => state?.module?.[moduleBridgeHex]?.userBridge
  );
  const [typeOptions, setTypeOptions] = useState();
  const [responsibleOptions, setResponsibleOptions] = useState();

  // < GET LISTS
  const getEditLists = async () => {
    try {
      const response = await axios.post(
        axiosPath(
          "api_r_user_module_legalCompliance_correctiveActions_taskUpdate_getEditLists"
        ),
        {
          moduleBridgeHex,
          plantHex,
          plantObligationID,
        }
      );
      return response.data;
    } catch (err) {}
  };
  useEffect(() => {
    getEditLists().then((r) => {
      setTypeOptions(r.typeOptions);
      setResponsibleOptions(r.responsibleOptions);
    });
  }, []);
  // > GET LISTS

  // < NEW TASK UPDATE
  const handleNewTaskUpdate = async (values) => {
    try {
      const response = await axios.post(
        axiosPath(
          "api_r_user_module_legalCompliance_correctiveActions_taskUpdate_new"
        ),
        toFormData({
          ...values,
          ...{
            moduleBridgeHex,
            plantHex,
            plantObligationID,
            taskID: selectedTask.id,
          },
        }),
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      dispatch(
        currentPageAction.change(
          'correctiveActionsTabs',
          { [plantObligationID]: response.data },
          true
        )
      );
      onCreated();
    } catch (err) {
      dispatch(errorHandler(err));
    }
  };
  // > NEW TASK UPDATE

  const validationSchema = Yup.object().shape({
    date: Yup.string().required(
      ReactDOMServer.renderToString(<Translator file="module-legalCompliance" name="must.select.date" />)
    ),
    type: Yup.mixed().required(
      ReactDOMServer.renderToString(<Translator file="module-legalCompliance" name="must.select.origin" />)
    ),
    comment: Yup.string().required(
      ReactDOMServer.renderToString(<Translator file="user" name="user.required" />)
    ),
  });

  return (
    <>
      <Formik
        validationSchema={validationSchema}
        validateOnChange={false}
        validateOnBlur={false}
        enableReinitialize
        initialValues={{
          date: Moment().format('DD/MM/YYYY'),
          limitDate: '',
          type: null,
          file: null,
          employees: [],
          owner: null,
          supervisor: null,
          controlUserStatus: null,
          comment: '',
          implantation: '0.00',
          efficacy: '0.00',
        }}
        onSubmit={handleNewTaskUpdate}
      >
        {({ setFieldValue, handleSubmit, values, isSubmitting, errors }) => (
          <>
            <div className="row-no-margin">
              <div className="row">
                <div className="col-lg-12">
                  <h3>
                    {ReactDOMServer.renderToString(
                      <Translator
                        file="module-legalCompliance"
                        name="new.action.code"
                        variables={{ code: selectedTask.code }}
                      />
                    )}
                  </h3>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-4">
                  <AppDatePicker
                    title={ReactDOMServer.renderToString(
                      <Translator
                        file="module-legalCompliance"
                        name="creation.date"
                      />
                    )}
                    value={values.date}
                    onChange={(opt) => setFieldValue('date', opt)}
                    placeholder="dd/mm/yyyy"
                    error={errors.date}
                  />
                </div>
                {permissions.gcl?.module?.submodules?.correctiveActions
                  ?.taskUpdateClosedSystem && (
                  <div className="col-lg-4">
                    <AppDatePicker
                      title={ReactDOMServer.renderToString(
                        <Translator
                          file="module-legalCompliance"
                          name="module.lc.limit.date"
                        />
                      )}
                      value={values.limitDate}
                      onChange={(opt) => setFieldValue('limitDate', opt)}
                      placeholder="dd/mm/yyyy"
                      error={errors.limitDate}
                    />
                  </div>
                )}
                <div className="col-lg-4">
                  {typeOptions && (
                    <AppSingleSelect
                      title={ReactDOMServer.renderToString(
                        <Translator
                          file="module-correctiveActions"
                          name="module.ca.task-type-2"
                        />
                      )}
                      icon={<AppRemixIcon icon="focus" />}
                      value={values.type}
                      options={typeOptions}
                      onChange={(v) => setFieldValue('type', v)}
                      error={errors.type}
                    />
                  )}
                </div>
                <div className="col-lg-4 pt-2">
                  <AppFileUploader
                    placeholder={values.file ? values.file[0].name : ''}
                    onChange={(opt) => setFieldValue('file', opt)}
                    btnText={<Translator file="general" name="search..." />}
                  />
                </div>
              </div>
              {permissions.gcl?.module?.submodules?.correctiveActions
                ?.supervisionSystem ? (
                <div className="row">
                  <div className="col-lg-4">
                    {userBridge?.permissions?.level === 0 ? (
                      responsibleOptions ? (
                        <AppSingleSelect
                          title={ReactDOMServer.renderToString(
                            <Translator
                              file="module-legalCompliance"
                              name="owner"
                            />
                          )}
                          icon={<AppRemixIcon icon="user" />}
                          value={values.owner}
                          options={responsibleOptions}
                          onChange={(v) => setFieldValue('owner', v)}
                          isLoading={!responsibleOptions}
                        />
                      ) : (
                        <></>
                      )
                    ) : (
                      <AppInput
                        title={ReactDOMServer.renderToString(
                          <Translator
                            file="module-legalCompliance"
                            name="owner"
                          />
                        )}
                        value={user.name}
                        isReadOnly
                      />
                    )}
                  </div>
                  <div className="col-lg-4">
                    {responsibleOptions && (
                      <AppSingleSelect
                        title={ReactDOMServer.renderToString(
                          <Translator
                            file="module-correctiveActions"
                            name="supervisor"
                          />
                        )}
                        icon={<AppRemixIcon icon="user" />}
                        value={values.supervisor}
                        options={responsibleOptions}
                        onChange={(v) => setFieldValue('supervisor', v)}
                        isLoading={!responsibleOptions}
                      />
                    )}
                  </div>
                  <div className="col-lg-4">
                    {userBridge?.permissions?.level != 0 && (
                      <AppSingleSelect
                        title={ReactDOMServer.renderToString(
                          <Translator file="user" name="user.state" />
                        )}
                        icon={<AppRemixIcon icon="user" />}
                        value={values.controlUserStatus}
                        options={[
                          {
                            label: ReactDOMServer.renderToString(
                              <Translator
                                file="module-correctiveActions"
                                name="not.accepted"
                              />
                            ),
                            value: 0,
                          },
                          {
                            label: ReactDOMServer.renderToString(
                              <Translator
                                file="module-correctiveActions"
                                name="accepted"
                              />
                            ),
                            value: 1,
                          },
                        ]}
                        onChange={(v) => setFieldValue('controlUserStatus', v)}
                      />
                    )}
                  </div>
                </div>
              ) : (
                <div className="row">
                  <div className="col-lg-12">
                    <AppMultiSelect
                      title={ReactDOMServer.renderToString(
                        <Translator
                          file="module-legalCompliance"
                          name="responsibles"
                        />
                      )}
                      placeholder={ReactDOMServer.renderToString(
                        <Translator
                          file="module-correctiveActions"
                          name="module.ca.filters.employee-select"
                        />
                      )}
                      icon={<AppRemixIcon icon="user" />}
                      value={values.employees}
                      options={responsibleOptions}
                      onChange={(v) => setFieldValue('employees', v)}
                      isLoading={!responsibleOptions}
                      hasSearchBox
                      hasSelectOptions
                    />
                  </div>
                </div>
              )}
              <div className="row">
                <div className="col-lg-12">
                  <AppTextArea
                    title={ReactDOMServer.renderToString(
                      <Translator
                        file="module-legalCompliance"
                        name="comment"
                      />
                    )}
                    height={
                      modulePermissions?.caAutoCalc &&
                      modulePermissions.caAutoCalc == 1
                        ? '140px'
                        : '190px'
                    }
                    isReadOnly
                    value={
                      <AppTextEditor
                        value={values.comment}
                        onChange={(opt) => setFieldValue('comment', opt)}
                        toolbar={{
                          toolbar: [['bold', 'italic']],
                        }}
                        height={117}
                      />
                    }
                    error={errors.comment}
                  />
                </div>
              </div>
              {modulePermissions?.caAutoCalc &&
                modulePermissions.caAutoCalc == 1 && (
                  <div className="row">
                    <div className="col-lg-6 pt-2">
                      <AppInputNumber
                        title={ReactDOMServer.renderToString(
                          <Translator
                            file="module-legalCompliance"
                            name="implantation"
                          />
                        )}
                        value={values.implantation}
                        icon={<AppRemixIcon icon="calendar" />}
                        onChange={(v) => setFieldValue('implantation', v)}
                        decimals={2}
                      />
                    </div>
                    <div className="col-lg-6 pt-2">
                      <AppInputNumber
                        title={ReactDOMServer.renderToString(
                          <Translator
                            file="module-correctiveActions"
                            name="efficacy"
                          />
                        )}
                        value={values.efficacy}
                        icon={<AppRemixIcon icon="calendar" />}
                        onChange={(v) => setFieldValue('efficacy', v)}
                        decimals={2}
                      />
                    </div>
                  </div>
                )}
              <div className="row">
                <div className="col-lg-12">
                  <div className="float-right">
                    <span
                      className="btn btn-outline-light mr-2"
                      onClick={() => onCreated()}
                    >
                      <Translator file="user" name="user.cancel" />
                    </span>
                    <span
                      className="btn btn-outline-info"
                      onClick={handleSubmit}
                    >
                      <Translator
                        file="user"
                        name="user.obligation.evidence.create"
                      />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </Formik>
    </>
  );
};
export default CorrectiveActionsNewTaskUpdate;
